import {
  handleCreateVoteRequest,
  handleDestroyVoteRequest,
  handleGetVotesRequest
} from '@/store/api/vote';

const state = {
  allVotes: []
};

const getters = {
  allVotes: ({ allVotes }) => {
    return allVotes;
  }
};

const actions = {
  async createVote({ commit, dispatch }, capsuleId) {
    const { data, message } = await handleCreateVoteRequest(capsuleId);

    if (data) {
      commit('APPEND_TO_ALL_VOTES', data['capsule_id']);

      const payload = {
        capsuleId: data['capsule_id'],
        counterName: 'votes_count',
        direction: 'up'
      }
      dispatch('adjustCapsuleCounter', payload)
    }
  },

  async destroyVote({ commit, dispatch }, capsuleId) {
    const { data, message } = await handleDestroyVoteRequest(capsuleId);

    if (data) {
      commit('REMOVE_FROM_ALL_VOTES', data.capsule_id)

      const payload = {
        capsuleId: data['capsule_id'],
        counterName: 'votes_count',
        direction: 'down'
      }
      dispatch('adjustCapsuleCounter', payload)
    }
  },

  async fetchVotes({ commit }, capsuleIds) {
    const { data } = await handleGetVotesRequest(capsuleIds);

    if (data) {
      commit('SAVE_TO_ALL_VOTES', data['capsule_ids']);
    }
  },

  async resetAllVotes({ commit }) {
    commit('RESET_ALL_VOTES');
  }
};

const mutations = {
  APPEND_TO_ALL_VOTES(state, id) {
    const votes = new Set([...state.allVotes])
    votes.add(id)

    state.allVotes = [...votes]
  },

  REMOVE_FROM_ALL_VOTES(state, id) {
    const votes = new Set([...state.allVotes])
    votes.delete(id)

    state.allVotes = [...votes]
  },

  RESET_ALL_VOTES(state) {
    state.allVotes = [];
  },

  SAVE_TO_ALL_VOTES(state, ids) {
    const votes = new Set([...state.allVotes, ...ids]);

    state.allVotes = [...votes]
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/vote/index.js